<mat-card class="m-auto padding12 home-card boxshadowgrey">
    <div>
        <button mat-icon-button color="primary" class="back-button" routerLink="/menu" (click)="clearList()">
            <mat-icon>arrow_back</mat-icon>
        </button>
    </div>
    <div class="content">
        <mat-card-title-group class="home-card" id="title">
            <mat-card-title>{{ "EXPERT.HEADER" | translate}}</mat-card-title>
        </mat-card-title-group>

        <ng-container *ngIf="!this.fetched">
            <div class="loading">
                <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner></div>
        </ng-container>

        <div class="button-group" *ngIf="this.fetched">
            <div class="selection">
                <mat-chip class="info">{{ "EXPERT.INFO" | translate}}: {{this.didList.length}}</mat-chip>
                <button mat-raised-button color="warn" [disabled]="this.didList.length == 0" class="delete" (click)="deleteSelection()" #tooltip="matTooltip" matTooltip="{{ 'EXPERT.TOOLTIP.DELETE' | translate}}" matTooltipPosition="below">{{ "EXPERT.BTN_DELETE" | translate }}</button>
            </div>
            <div class="continue-group">
                <ng-container *ngIf="this.roleService.isRole('Admin') || this.roleService.isRole('Expert')">
                    <button mat-raised-button color="primary" [disabled]="!this.roleService.isRole('Admin') || !this.roleService.isRole('Expert') || !writeChecked" class="continue" routerLink="/dataParameter" #tooltip="matTooltip" matTooltip="{{ 'EXPERT.TOOLTIP.PARAMETER' | translate}}" matTooltipPosition="below">{{ "EXPERT.BTN_PARAMETER" | translate }}</button>
                </ng-container>
                <button mat-raised-button color="primary" [disabled]="!checked" class="continue" routerLink="/dataDisplay" #tooltip="matTooltip" matTooltip="{{ 'EXPERT.TOOLTIP.CONTINUE' | translate}}" matTooltipPosition="below">{{ "EXPERT.BTN_CONTINUE" | translate }}</button>
            </div>
        </div>
        
        <mat-card-content id="content" *ngIf="this.fetched">
            <app-did-mapping-table
            [ecuDidMapping]="didMapping"
            class="didmappingtable-component"
            ></app-did-mapping-table>
        </mat-card-content>
        
    </div>
    
</mat-card>


